module.exports = __webpack_public_path__ + "img/review-request-woman.c13cdd62.svg";